import { render } from "./WebsiteFrontend.vue?vue&type=template&id=023213f6"
import script from "./WebsiteFrontend.vue?vue&type=script&lang=js"
export * from "./WebsiteFrontend.vue?vue&type=script&lang=js"

import "./WebsiteFrontend.vue?vue&type=style&index=0&id=023213f6&lang=scss"

import exportComponent from "/home/kreativ-mobil.com/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__